"use client";

import IconMenu from "@/app/(components)/generics/Icons/IconMenu";
import Logo from "@/app/(components)/generics/Logo/Logo";
import { SidebarStore } from "@/app/stores/SidebarStore";
import styles from "./Header.module.css";

export default function Header() {
  const toggleSidebar = SidebarStore((state) => state.toggleSidebar);

  return (
    <header className={styles.container}>
      <button className={styles.toggleBtn} onClick={toggleSidebar}>
        <IconMenu />
      </button>

      <Logo />
    </header>
  );
}
